/**
 * Enum for agent permission values.
 * Consist all values respective to its permission keys.
 * @readonly
 * @example PermissionValues 
 */
export enum PermissionValues{
    VIEW = "View",
    EDIT = "Edit",
    ENABLE = "Enable",
    AGENT_CONFIG = "AgentConfig",
    HIDE = "Hide"
}